import React, { useState } from 'react';
import classNames from 'classnames';
import { Modal  } from 'antd';
import Button from "components/button";
import IndexModal from "components/modal";

function ButtonWithConfirm({confirmHandler, 
    children, 
    confirmationMessage, 
    className, 
    confirmationTitle='Confirm Action', 
    cancelLabel='Cancel',
    confirmLabel='Confirm',
    ...rest}) 
    {
	
	const buttonClassName = classNames('',className);
	const [open, setOpen] = useState(false);
	
	const processHandler = () => {
        if(confirmHandler){
            confirmHandler();
        }
        setOpen(false);
	};
	
    return (<>
    	<Button className={buttonClassName.trim()} 
    		{...rest}
    		onClick={(e) => {e.preventDefault();setOpen(true)}}
		>
  			{children}
		</Button>
        <IndexModal
            open={open}
            onClose={() => {setOpen(false)}}
            useCustomClass
            width="sm:max-w-lg max-w-2xl"
            maxContentHeight="85vh"
            title={null}
            closable={false}
        >
            <div className="grid w-full gap-4 rounded-xl border p-6 shadow-xl max-w-lg">
                <div className="flex flex-col gap-2 text-left">
                    <h2 className="text-lg font-semibold">
                        {confirmationTitle}
                    </h2>
                    <div className="text-sm muted-text">
                    {confirmationMessage ? 
                        confirmationMessage 
                        :            
                        "Are you sure you want to continue?"
                    }
                    </div>
                </div>

                <div className="flex flex-col-reverse gap-2 sm:flex-row sm:justify-end">
                    <Button
                        onClick={() => {setOpen(false)}}
                        className="inline-flex items-center justify-center gap-2 px-4 py-2 h-9
                                rounded-lg border hover:shadow-none hover:bg-slate-100"
                    >
                        {cancelLabel}
                    </Button>

                    <Button
                        onClick={processHandler}
                        className="access-button btn-advance"
                    >
                        {confirmLabel}
                    </Button>
                </div>
            </div>
        </IndexModal>

		{/* <Modal
            open={open}
            closeIcon={false}
            centered
            title={<h2 className="popup-modal-title ">{confirmationTitle}</h2>}
            okText="Confirm"
            cancelText="Cancel"
            footer={(_) => (
                <>
                    <Button className="me-4" 
                        onClick={() => {setOpen(false)}}
                    >
                        {cancelLabel}
                    </Button>
                    <Button className="btn-primary" 
                        onClick={processHandler}
                    >
                        {confirmLabel}
                    </Button>
                </>
            )}
        >
            <div className='content-wrapper'>
                {confirmationMessage && <div>{confirmationMessage}</div>}            
                <div>Are you sure you want to continue?</div>
            </div>
        </Modal> */}
    </>);
}

export default ButtonWithConfirm;



